import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '网红黑料', href: '/category/wanghong-heidiao' },
  { label: '明星塌房', href: '/category/mingxing-tafang' },
  { label: '直播吃瓜', href: '/category/zhibo-chigua' },
  { label: '娱乐八卦', href: '/category/yule-bagua' },
  { label: '黑料视频', href: '/category/shipin-heiliao' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              17吃瓜
            </span>
            <span className="hidden md:inline-block px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-full font-label">
              官网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 text-sm font-label rounded-lg transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-label text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <a
              href="#subscribe"
              className="px-5 py-2 text-sm font-label bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              订阅爆料
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 text-sm font-label rounded-lg transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-label text-foreground-600 rounded-lg hover:bg-background-100"
            >
              关于我们
            </Link>
            <a
              href="#subscribe"
              className="mt-2 px-5 py-3 text-sm font-label bg-primary-500 text-background-50 rounded-lg text-center hover:bg-primary-600 transition-colors"
            >
              订阅爆料
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}